export default function VerticalDots({ color = 'rgba(0, 0, 0, 0.8)' }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d={
          'M10.0002 13.3335C10.4422 13.3335 10.8661 13.5091 11.1787 13.8217C11.4912 14.1342 ' +
          '11.6668 14.5581 11.6668 15.0002C11.6668 15.4422 11.4912 15.8661 11.1787 16.1787C10.8661 16.4912 ' +
          '10.4422 16.6668 10.0002 16.6668C9.55814 16.6668 9.13421 16.4912 8.82165 16.1787C8.50909 15.8661 ' +
          '8.3335 15.4422 8.3335 15.0002C8.3335 14.5581 8.50909 14.1342 8.82165 13.8217C9.13421 13.5091 9.55814 ' +
          '13.3335 10.0002 13.3335ZM10.0002 8.3335C10.4422 8.3335 10.8661 8.50909 11.1787 8.82165C11.4912 9.13421 ' +
          '11.6668 9.55814 11.6668 10.0002C11.6668 10.4422 11.4912 10.8661 11.1787 11.1787C10.8661 11.4912 ' +
          '10.4422 11.6668 10.0002 11.6668C9.55814 11.6668 9.13421 11.4912 8.82165 11.1787C8.50909 10.8661 ' +
          '8.3335 10.4422 8.3335 10.0002C8.3335 9.55814 8.50909 9.13421 8.82165 8.82165C9.13421 8.50909 9.55814 ' +
          '8.3335 10.0002 8.3335ZM10.0002 3.3335C10.4422 3.3335 10.8661 3.50909 11.1787 3.82165C11.4912 4.13421 ' +
          '11.6668 4.55814 11.6668 5.00016C11.6668 5.44219 11.4912 5.86611 11.1787 6.17867C10.8661 6.49123 ' +
          '10.4422 6.66683 10.0002 6.66683C9.55814 6.66683 9.13421 6.49123 8.82165 6.17867C8.50909 5.86611 ' +
          '8.3335 5.44219 8.3335 5.00016C8.3335 4.55814 8.50909 4.13421 8.82165 3.82165C9.13421 3.50909 9.55814 ' +
          '3.3335 10.0002 3.3335Z'
        }
        fill={color}
      />
    </svg>
  );
}
